import cx from 'clsx';
import React from 'react';

import { ReactComponent as TranslationIcon } from '@assets/svg/ic-translation.svg';

import LoaderGif from '@components/common/LoaderGif/LoaderGif';

import useTranslation from '@hooks/useTranslation';

import { selectAITranslateProfileLanguageName } from '@pages/ActionItem/store/useAITranslateStore';

import style from './style.module.scss';

interface IProps {
  isTranslated: boolean;
  hasTranslate: boolean;
  isTranslateLoading: boolean;
  toggleIsTranslate: () => void;
}

const TranslateBtn: React.FC<IProps> = ({
  isTranslated,
  hasTranslate,
  isTranslateLoading,
  toggleIsTranslate,
}) => {
  const { t } = useTranslation();

  const profileLanguageName = selectAITranslateProfileLanguageName();

  if (!hasTranslate) {
    return null;
  }

  return (
    <div
      className={cx(style.translateBlock, { [style.disabledTranslate]: isTranslateLoading })}
      onClick={toggleIsTranslate}
    >
      {isTranslateLoading && <LoaderGif className={style.loader} />}
      <TranslationIcon className={style.translationIcon} />
      <span className={style.translateLang}>
        {t(`To ${isTranslated ? 'original' : profileLanguageName}`)}
      </span>
    </div>
  );
};

export default TranslateBtn;
